module.exports = __webpack_public_path__ + "img/rate2.ad97cd02.png";